import { render, staticRenderFns } from "./crud.vue?vue&type=template&id=c978c9b2&scoped=true&"
import script from "./crud.vue?vue&type=script&lang=js&"
export * from "./crud.vue?vue&type=script&lang=js&"
import style0 from "./crud.vue?vue&type=style&index=0&id=c978c9b2&prod&lang=css&"
import style1 from "./crud.vue?vue&type=style&index=1&id=c978c9b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c978c9b2",
  null
  
)

export default component.exports